import VueInfiniteScrollBetter from "vue3-infinite-scroll-better";
export default VueInfiniteScrollBetter;
